

import { TrainingSession } from '@/types/training';
import { WeeklyInsight } from './types/insights';
import { SessionDetailsDialog } from '@/features/training-journal/components/SessionDetailsDialog';
import { InsightDetailsDialog } from './InsightDetailsDialog';

interface TimelineDialogsProps {
  selectedSession: TrainingSession | null;
  selectedInsight: WeeklyInsight | null;
  isSessionDialogOpen: boolean;
  isInsightDialogOpen: boolean;
  sortedSessions: TrainingSession[];
  currentIndex: number | null;
  onSessionDialogOpenChange: (open: boolean) => void;
  onNavigate: (newIndex: number) => void;
  onInsightDialogOpenChange: (open: boolean) => void;
}

export function TimelineDialogs({
  selectedSession,
  selectedInsight,
  isSessionDialogOpen,
  isInsightDialogOpen,
  sortedSessions,
  currentIndex,
  onSessionDialogOpenChange,
  onNavigate,
  onInsightDialogOpenChange
}: TimelineDialogsProps) {
  return (
    <>
      <SessionDetailsDialog
        session={selectedSession}
        open={isSessionDialogOpen}
        onOpenChange={onSessionDialogOpenChange}
        sessions={sortedSessions}
        currentIndex={currentIndex ?? undefined}
        onNavigate={onNavigate}
      />

      <InsightDetailsDialog
        insight={selectedInsight}
        open={isInsightDialogOpen}
        onOpenChange={onInsightDialogOpenChange}
      />
    </>
  );
}
